"use strict";

var computedCodeStyle;

function getComputedCodeStyle() {
  if (!computedCodeStyle) {
    var div = document.createElement("code");

    div.style.display = "none";
    div.className = "language-xxx";

    document.body.appendChild(div);

    computedCodeStyle = window.getComputedStyle(div);
  }

  return computedCodeStyle;
}

module.exports = getComputedCodeStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/spectacle-code-slide/lib/getComputedCodeStyle.js
// module id = 1420
// module chunks = 0